import { useOptionalContent, UseOptionalContentResult } from './useOptionalContent';
import { UseContentSelector } from './selectors';

type UseRequiredContentResult<T> = Required<Pick<UseOptionalContentResult<T>, 'data' | 'refresh'>>;

/**
 * Variation of `useOptionalContent` that will throw if the content is fetching or not ready yet
 */
export const useRequiredContent = <Result, Transformed>(selector: UseContentSelector<Result, Transformed>): UseRequiredContentResult<Transformed> => {
  const { isFetching, data, refresh } = useOptionalContent(selector);

  if (isFetching) {
    throw new Error('Called useContent when content is fetching');
  }

  if (!data) {
    throw new Error('Called useContent when data is not ready');
  }

  return {
    data,
    refresh,
  };
};
